// Pinned client 1.26.0 correlation: event_id, optional response_id.
// Corrections arrive through onAgentResponseCorrection, not onMessage.
export const emptyTranscript = () => ({ rows: [], sequence: 0 });
const present = value => (typeof value === 'string' && value.length > 0) || (typeof value === 'number' && Number.isFinite(value));
function match(rows, role, payload) {
  if (present(payload.response_id)) {
    const found = rows.findIndex(row => row.role === role && row.response_id === payload.response_id);
    if (found !== -1) return found;
  }
  if (present(payload.event_id)) {
    return rows.findIndex(row => row.role === role && row.event_id === payload.event_id &&
      (!present(payload.response_id) || !present(row.response_id)));
  }
  return -1;
}
export function transcriptMessage(state, payload) {
  if (!['user', 'agent'].includes(payload.role) || typeof payload.message !== 'string') return state;
  const index = match(state.rows, payload.role, payload);
  if (index !== -1) {
    const previous = state.rows[index];
    // A retransmitted pre-correction response must not undo a confirmed correction.
    if (previous.corrected) return state;
    const updated = { ...previous, text: payload.message,
      response_id: payload.response_id ?? previous.response_id,
      event_id: payload.event_id ?? previous.event_id };
    return { ...state, rows: state.rows.map((row, i) => i === index ? updated : row) };
  }
  const sequence = state.sequence + 1;
  return { sequence, rows: [...state.rows, { key: `turn:${sequence}`, role: payload.role,
    text: payload.message, event_id: payload.event_id, response_id: payload.response_id }] };
}
export function transcriptCorrection(state, payload) {
  if (typeof payload.corrected_agent_response !== 'string' ||
      (!present(payload.event_id) && !present(payload.response_id))) return state;
  const index = match(state.rows, 'agent', payload);
  if (index === -1) {
    const appended = transcriptMessage(state, { ...payload, role: 'agent', message: payload.corrected_agent_response });
    return { ...appended, rows: appended.rows.map((row, i) => i === appended.rows.length - 1 ? { ...row, corrected: true } : row) };
  }
  return { ...state, rows: state.rows.map((row, i) => i === index ? { ...row,
    text: payload.corrected_agent_response, corrected: true,
    response_id: payload.response_id ?? row.response_id } : row) };
}

// Display-only voice directions. Preserve raw SDK events, spoken audio, user text,
// scientific brackets and reference markers. Unknown tags remain visible.
const voiceDirection = /(?:[ \t]*\[(?:happy|sad|excited|angry|curious|nervous|calm|surprised|laughs|laughing|chuckles|chuckling|whispers|whispering|sighs|sighing|slow|crying|sarcastic|thoughtful|serious|warm|cheerful|confident)\][ \t]*)+/gi;
export function transcriptDisplayText(row) {
  if (row.role !== 'agent') return row.text;
  return row.text.replace(voiceDirection, (tag, offset, original) => {
    const before = original[offset - 1];
    const after = original[offset + tag.length];
    return before && after && !/[\r\n]/.test(before + after) &&
      !/[,.;:!?)}\]]/.test(after) ? ' ' : '';
  });
}
